import Home from '@/pages/home/page';

export default function Recommend() {
  return <Home />;
}
